export default __webpack_public_path__ + "static/media/proj3.37cbb24b.png";